// extracted by css-extract-rspack-plugin
export default {"list":"Rhxey","tab":"sJb2e","tabLabel":"WNtEw","tabSection":"IcfZw"};